// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d5-a";
export var fulfillmentFormRail = "_d5-9";
export var headerTitleRow = "_d5-c";
export var orderDetailsWrapper = "_d5-7";
export var orderLinkTrigger = "_d5-2";
export var paymentInformationGrid = "_d5-h";
export var paymentSummaryColumn = "_d5-i";
export var shipmentContainer = "_d5-b";
export var shipmentDetailsMainPane = "_d5-8";
export var shipmentNavigationCard = "_d5-5";
export var shipmentNavigationRail = "_d5-3";
export var shipmentNavigationRailHeader = "_d5-4";
export var shipmentSummaryFact = "_d5-e";
export var shipmentSummaryGrid = "_d5-d";
export var shipmentSummaryMetadataRow = "_d5-f";
export var shipmentSummaryTags = "_d5-g";
export var shipmentWorkspace = "_d5-0";
export var shipmentWorkspaceContent = "_d5-6";
export var shipmentWorkspaceHeader = "_d5-1";